var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.233 8c0-.128.066-.273.165-.369l7.687-7.47a.577.577 0 0 1 .38-.161c.131 0 .28.064.379.16l.825.802a.515.515 0 0 1 .164.369.545.545 0 0 1-.165.368L6.186 8l6.482 6.3c.1.097.165.241.165.37a.545.545 0 0 1-.165.368l-.824.802a.576.576 0 0 1-.38.16.576.576 0 0 1-.38-.16L3.399 8.369A.545.545 0 0 1 3.233 8Z","fill":"#EA650D"}));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
